module.exports = __webpack_public_path__ + "CopingStyle3.png?a28ada9a42ab6e806f3bc5f22bf556b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/CopingStyle3.png
// module id = 126
// module chunks = 0